export const classes = {
  paper:
    'rounded-2xl border border-white/70 bg-white/[0.94] shadow-glass backdrop-blur-[30px] dark:border-white/[0.14] dark:bg-[#211d2f]/[0.82] dark:shadow-glass-dark',
};

export const styles = {
  menu: {
    '& .MuiList-root': {
      minWidth: '120px',
      paddingTop: '0.25rem',
      paddingBottom: '0.25rem',
    },
  },
};
